module.exports = __webpack_public_path__ + "src/assets/img/logo_bvds_trans.105c66a4.png";